import { render, staticRenderFns } from "./ParametersModal.vue?vue&type=template&id=bfe9d16a&scoped=true"
import script from "./ParametersModal.vue?vue&type=script&lang=ts"
export * from "./ParametersModal.vue?vue&type=script&lang=ts"
import style0 from "./ParametersModal.vue?vue&type=style&index=0&id=bfe9d16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe9d16a",
  null
  
)

export default component.exports